var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupYahooLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6B0094",
    d: "M89 2c50.455 0 89 37.449 89 86.493C178 137.536 139.455 175 89 175S0 137.536 0 88.493C0 39.449 38.545 2 89 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M85.12 58.054c.206-3.028.426-6.041.85-9.054H18v9.054c6.828.428 13.465 1.078 20.308 1.506 12.82 15.73 25.64 31.46 38.681 47.396v24.355c-7.267.65-14.535 1.078-21.802 1.728V141h67.12v-7.96c-7.267-.444-14.534-.65-21.802-.872.22-8.61.425-17.443.645-26.069 12.6-11.21 25.011-22.405 37.407-33.615 6.403-.429 12.82-.857 19.443-1.507v-10.56c-19.018.221-37.832.428-56.85.857v8.847c7.048.428 14.11.635 21.158.856-9.187 7.976-18.389 15.73-27.575 23.705C85.326 83.044 75.919 71.2 66.513 59.56c6.198-.65 12.395-1.078 18.608-1.506z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupYahooLogo);
export default __webpack_public_path__ + "static/media/SignupYahooLogo.b5908f7c5d9b8c866366aacb76e3323c.svg";
export { ForwardRef as ReactComponent };